


















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ProblemSection, StudentHistoryRecord } from "@/store/types";
import { setTimeout } from "timers";

@Component
export default class StatisticCard extends Vue {
  @Prop() history!: StudentHistoryRecord[];

  get problemSolved(): number {
    const solved = this.history.filter(record => record.solved);
    return solved.length;
  }

  get problemNotSolved(): number {
    const solved = this.history.filter(record => !record.solved);
    return solved.length;
  }

  get limitsSolved(): number {
    const solved = this.history.filter(
      record => record.solved && record.section === ProblemSection.limits
    );
    return solved.length;
  }

  get limitsNotSolved(): number {
    const solved = this.history.filter(
      record => !record.solved && record.section === ProblemSection.limits
    );
    return solved.length;
  }

  get derivativesSolved(): number {
    const solved = this.history.filter(
      record => record.solved && record.section === ProblemSection.derivatives
    );
    return solved.length;
  }

  get derivativesNotSolved(): number {
    const solved = this.history.filter(
      record => !record.solved && record.section === ProblemSection.derivatives
    );
    return solved.length;
  }

  get integralsSolved(): number {
    const solved = this.history.filter(
      record => record.solved && record.section === ProblemSection.integrals
    );
    return solved.length;
  }

  get integralsNotSolved(): number {
    const solved = this.history.filter(
      record => !record.solved && record.section === ProblemSection.integrals
    );
    return solved.length;
  }
}
